




import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import IssuePc from '@/components/ViewComponent/Issue/IssuePc.vue';

@Component<Issue>({
  components: { IssuePc },
})
export default class Issue extends Vue {}
